<template>
  <div class="hello">
    <sui-button floated="left" content="Back" icon="backward" @click="$router.go(-1)" />
    <sui-button floated="right" content="Refresh" icon="refresh" v-on:click="refresh()" />
    <div v-if="alias">
        <h1>Channel {{ alias.alias }}</h1>
        
        <sui-grid>
            <sui-grid-row>
                <sui-grid-column>
                    <h3 is="sui-header" attached="top">Data</h3>
                    <sui-segment attached>
                        <ListHistory :alias="alias.alias" displayDeviceId />
                    </sui-segment>
                </sui-grid-column>
            </sui-grid-row>
            <sui-grid-row :columns="2">
                <sui-grid-column>
                    <h3 is="sui-header" attached="top">Devices</h3>
                    <sui-segment attached>
                        <sui-table single-line>
                          <sui-table-header>
                            <sui-table-row>
                              <sui-table-header-cell>Id</sui-table-header-cell>
                              <sui-table-header-cell>Type</sui-table-header-cell>
                              <sui-table-header-cell>Detail</sui-table-header-cell>
                            </sui-table-row>
                          </sui-table-header>
                          <sui-table-body>
                          <sui-table-row v-for="device in alias.devices" :key="device.deviceId">
                              <sui-table-cell>{{ device.deviceId }}</sui-table-cell>
                              <sui-table-cell>{{ device.type }}</sui-table-cell>
                              <sui-table-cell><router-link :to="'/device/' + device.deviceId" class="nav-link" icon="detail"><sui-button content="Detail" icon="eye" positive  size="mini" /></router-link></sui-table-cell>
                          </sui-table-row>
                            
                          </sui-table-body>
                        </sui-table>    
                    </sui-segment>
                </sui-grid-column>
                <sui-grid-column>
                    
                </sui-grid-column>
            </sui-grid-row>
        </sui-grid>
        
        
    </div>
    <div v-else>
        <h1>...</h1>
    </div>
    
    
  </div>
</template>

<script>
import DziService from '@/DziService'
import ListHistory from '@/components/Device/ListHistory.vue';


export default {
  name: 'AliasDetail',
  data () {
        return {
            alias: null,
        }
    },  
  props: {
//    msg: String
  },
  methods: {
        refresh() {
          this.alias = null;
          this.getAlias();  
        },
        async getAlias () {
            const response = await DziService.getAlias(this.$route.params.id)
            this.alias = response.data;
        },
    },
    mounted () {
        this.getAlias();
        },
        components: {
            ListHistory
        }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
